import { Helper } from '../../../../../classes/helper'
import {
  panelDimensions,
  solarCellThickness,
} from '../../model/helper/verandaDimensions'

export const SolarPanelGeometry = (props: {
  position: number[]
  children?: React.ReactNode
  material: THREE.Material
}) => {
  return (
    <mesh
      position={props.position as any}
      rotation={[Helper.convertAngleToRadiant(90), 0, 0]}
      castShadow
      material={props.material}
    >
      <boxGeometry
        args={[panelDimensions, panelDimensions, solarCellThickness]}
      />
      {props.children}
    </mesh>
  )
}
